import { Component } from "@angular/core";
import { FeedbackService, FeedbackComponent } from "@cibg/ui-components";
import { HeaderComponent } from "./components/header/header.component";
import { RouterOutlet } from "@angular/router";
@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    imports: [HeaderComponent, FeedbackComponent, RouterOutlet]
})
export class AppComponent {
    constructor(public readonly feedbackService: FeedbackService) {}
}
